export class renameSetProduct {
    indexProduct: number;
    indexCat: number;
    name: string;
    constructor(indexProduct,indexCat,name) {
        this.indexProduct = indexProduct;
        this.indexCat = indexCat;
        this.name = name;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/rename/rename-set-product.ts